(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfFpcMissing', [
    function() {
      return {
        restrict: 'A',
        require: '?ngModel',
        link: (function(_this) {
          return function($scope, element, attrs, ctrl) {
            var run;
            run = function() {
              var attr, inputName, match;
              if ($scope.service.savedSteps.indexOf($scope.service.currentStepName) === -1) {
                return;
              }
              element.addClass('fieldprint');
              if (attrs.mfFpcMissing) {
                attr = attrs.mfFpcMissing;
              } else if (attrs.ngModel) {
                attr = attrs.ngModel;
              }
              if (attr) {
                if (match = attr.match(/\[([^\]]+)\]$/)) {
                  match = match[1];
                  if (match = match.match(/^['"](.*)['"]$/)) {
                    inputName = match[1];
                  } else {
                    inputName = $scope.$parent.inputName;
                  }
                } else {
                  if (match = attr.match(/\.([^\.]+)$/)) {
                    inputName = match[1];
                  }
                }
              }
              if (element[0] && element[0].id === 'mgmtSys') {
                inputName = 'management_system';
              }
              if (!inputName) {
                throw Error("Fieldprint orange validation: Could not find input name for ng-model " + attrs.ngModel);
              }
              $scope.service.updateCompletenessFor(element, inputName);
              if (($scope.service.fpcResult.completeness.inputs[inputName] != null) && !$scope.service.fpcResult.completeness.inputs[inputName]) {
                return element.addClass('missing');
              }
            };
            $scope.service.onDataLoaded($scope, function() {
              return run();
            });
            return $scope.$watch(attrs.mfFpcMissingTrigger, function() {
              return run();
            });
          };
        })(this)
      };
    }
  ]);

}).call(this);
